export default "__VITE_ASSET__BQ5zqA$I__"